import stylesheet_16 from '../stylesheets/16.js';
import stylesheet_15 from '../stylesheets/15.js';
import stylesheet_17 from '../stylesheets/17.js';

export const index = 9;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/services/accelerated-training/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/9.76843ca0.js","_app/immutable/chunks/scheduler.cba25ae0.js","_app/immutable/chunks/index.e8799153.js","_app/immutable/chunks/Wrapper.5a8cf0a2.js","_app/immutable/chunks/Hero.4ba03ae5.js","_app/immutable/chunks/each.4a3b5091.js","_app/immutable/chunks/ContentCard.442de305.js"];
export const stylesheets = ["_app/immutable/assets/Wrapper.54de1bd5.css","_app/immutable/assets/Hero.71a30b75.css","_app/immutable/assets/ContentCard.378eb474.css"];
export const fonts = [];
export const inline_styles = () => ({
	"_app/immutable/assets/Wrapper.54de1bd5.css": stylesheet_16,
	"_app/immutable/assets/Hero.71a30b75.css": stylesheet_15,
	"_app/immutable/assets/ContentCard.378eb474.css": stylesheet_17
});
